import React from "react";
import {useFeedbackTools} from "../../../../components/FeedbackTools";
import useDialog from "../../../../hooks/useDialog";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Divider from "@mui/material/Divider";
import EditPropertyInstructionDialog from "./EditPropertyInstructionDialog";
import {OptionalContent} from "../../../../components/OptionalContent";


const PropertyInstructionList = ({title, propertyInstructionCategory, propertyInstructions, onSave}) => {
    const {showErrorNotification, showSuccessNotification, askConfirmation} = useFeedbackTools();
    const [editingInstruction, setEditingInstruction] = React.useState(null);
    const editInstructionDialog = useDialog();

    const handleNewInstruction = () => {
        setEditingInstruction({id: null, contentIt: '', contentEn: '', category: propertyInstructionCategory});
        editInstructionDialog.open();
    }

    const handleEditInstruction = (instruction) => {
        setEditingInstruction(instruction);
        editInstructionDialog.open();
    }

    const handleDeleteInstruction = async (instructionId) => {
        const innerDelete = async () => {
            try {
                await onSave({propertyInstructionsAttributes: [{id: instructionId, _destroy: true}]});
                showSuccessNotification('Elemento eliminato con successo');
            } catch (e) {
                showErrorNotification(e);
            }
        }

        askConfirmation({
            title: "Elimina elemento",
            description: `Confermando sarà eliminato l'elemento. Confermi l'eliminazione dell'elemento selezionato?`,
            confirmationText: 'Si',
            cancellationText: 'No',
            onConfirm: innerDelete
        });
    }

    const handleSaveInstruction = async (instructionData) => {
        await onSave({propertyInstructionsAttributes: [instructionData]});
    }

    const handleCloseEditInstructionDialog = () => {
        editInstructionDialog.close();
        setEditingInstruction(null);
    }

    return <Stack>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{px: 2, pt: 2}}>
            <Typography variant="body1" fontWeight={600}>
                {title}
            </Typography>
            <Button color="primary"
                    onClick={handleNewInstruction}
                    size="small"
                    startIcon={<AddIcon fontSize="inherit"/>}>
                Aggiungi
            </Button>
        </Stack>
        <OptionalContent hasContent={propertyInstructions.length > 0}
                         showIcon={true}
                         noContentMessage="Nessun elemento presente">
            <List>
                {
                    propertyInstructions.map((instruction, i) => (
                        <div key={instruction.id}>
                            <ListItem disablePadding key={instruction.id}>
                                <ListItemButton dense onClick={() => handleEditInstruction(instruction)} disabled={instruction.isInherited}>
                                    <ListItemText primary={instruction.contentIt ?? ''}
                                                  primaryTypographyProps={{whiteSpace: "pre-wrap"}}/>
                                </ListItemButton>
                                <Stack direction="row" spacing={1} alignItems="center" sx={{flexWrap: "noWrap", pr: 2}}>
                                    <IconButton size="small"
                                                sx={{px: 0}}
                                                disabled={instruction.isInherited}
                                                onClick={() => handleEditInstruction(instruction)}>
                                        <EditIcon fontSize="inherit"/>
                                    </IconButton>
                                    <IconButton size="small"
                                                color="error"
                                                sx={{px: 0}}
                                                disabled={instruction.isInherited}
                                                onClick={() => handleDeleteInstruction(instruction.id)}>
                                        <DeleteIcon fontSize="inherit"/>
                                    </IconButton>
                                </Stack>
                            </ListItem>
                            {i !== propertyInstructions.length - 1 && <Divider/>}
                        </div>
                    ))
                }
            </List>
        </OptionalContent>

        {
            editInstructionDialog.show && !!editingInstruction &&
            <EditPropertyInstructionDialog instruction={editingInstruction}
                                           dialog={editInstructionDialog}
                                           onClose={handleCloseEditInstructionDialog}
                                           onSave={handleSaveInstruction}
            />
        }
    </Stack>
}

export default PropertyInstructionList;